function normalizeTicker(value) {
  return String(value || "").trim().toUpperCase();
}

export function getRequestedCurationParams(search) {
  const params = new URLSearchParams(search);
  const requestedSeltype = params.get("seltype");
  const requestedTicker = normalizeTicker(params.get("ticker"));

  return {
    requestedSeltype: requestedSeltype || null,
    requestedTicker: requestedTicker || null,
  };
}

function findTickerIndex(items, ticker) {
  const normalizedTicker = normalizeTicker(ticker);
  if (!normalizedTicker || !Array.isArray(items)) {
    return -1;
  }

  return items.findIndex((item) => normalizeTicker(item?.ticker) === normalizedTicker);
}

export function findMatchingTicker(items, ticker) {
  const index = findTickerIndex(items, ticker);
  return index === -1 ? null : items[index]?.ticker || null;
}

export function resolveTickerPage(items, ticker, pageSize) {
  const normalizedPageSize = Number(pageSize);
  const safePageSize = Number.isFinite(normalizedPageSize) && normalizedPageSize > 0
    ? normalizedPageSize
    : 10;
  const index = findTickerIndex(items, ticker);

  if (index === -1) {
    return 1;
  }

  return Math.floor(index / safePageSize) + 1;
}
